export default __webpack_public_path__ + "tmp_src/components/VideoTrigger/VideoTrigger.css.liquid";